var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-secondary-1", class: _vm.isMobile && "row" },
    [
      _c(
        "div",
        { staticClass: "p-1", class: _vm.isMobile && "col-12" },
        [
          _c("VisitCalendarDateRangeSelector", {
            attrs: {
              "academic-year-info": _vm.academicYearInfo,
              "show-week-range": true,
              "view-mode": _vm.currentViewMode,
              year: _vm.year
            },
            on: { "on-datarange-changed": _vm.onDatarangeChanged }
          })
        ],
        1
      ),
      _c("div", { staticClass: "pt-2 bg-white" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 col-lg-4 mb-2 mb-md-0" },
            [
              _c("visit-calendar-mode", {
                on: {
                  "on-viewmode-changed": _vm.onViewModeChanged,
                  "value-day-week": _vm.onCalendarViewChange
                },
                model: {
                  value: _vm.currentViewMode,
                  callback: function($$v) {
                    _vm.currentViewMode = $$v
                  },
                  expression: "currentViewMode"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12 col-lg-8" },
            [
              _c("visit-calendar-day", {
                attrs: {
                  dates: _vm.dates,
                  days: _vm.days,
                  "is-mobile": _vm.isMobile,
                  value: _vm.currentViewMode
                }
              })
            ],
            1
          )
        ])
      ]),
      _c("div", { staticClass: "bg-white" }, [
        _c(
          "div",
          { staticClass: "row" },
          _vm._l(_vm.filteredStudents, function(student) {
            return _c(
              "div",
              { key: student.hour.label, staticClass: "col-12" },
              [
                _c("custom-pill", {
                  staticClass: "col-12 col-md-2 gray-12",
                  attrs: { text: student.hour.label }
                }),
                _c(
                  "div",
                  { staticClass: "row container-flex student-box" },
                  _vm._l(student.students, function(studentItem) {
                    return _c("VisitStudentRow", {
                      key: studentItem.id,
                      ref: "rowRef",
                      refInFor: true,
                      staticClass: "mb-3 col-sm-12",
                      attrs: {
                        "academic-year-id": _vm.academicYearId,
                        days: _vm.days,
                        "end-date": student.endDate,
                        hour: student.hour,
                        "is-mobile": _vm.isMobile,
                        "justification-options": _vm.justificationOptions,
                        "months-period-finalized": _vm.monthsPeriodFinalized,
                        "start-date": student.startDate,
                        types: _vm.visitTypes,
                        value: studentItem,
                        "view-mode": _vm.currentViewMode
                      },
                      on: {
                        "download-absence-document":
                          _vm.onDownloadAbsenceDocument,
                        "save-edition": _vm.onSaveEdition,
                        "update-schedule": _vm.onUpdateSchedule
                      }
                    })
                  }),
                  1
                )
              ],
              1
            )
          }),
          0
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }